const trackingDirective = (app) => {
  app.directive('track-click', {
    mounted(el, binding) {
      const handler = () => {
        if (typeof binding.value === 'function') binding.value();
      };
      el._trackClickHandler = handler;
      el.addEventListener('click', handler);
    },
    unmounted(el) {
      if (el._trackClickHandler) {
        el.removeEventListener('click', el._trackClickHandler);
        delete el._trackClickHandler;
      }
    }
  });
};

export default trackingDirective;
